<div class="flex items-center justify-between w-full pr-4 md:pr-6 gap-2">
    <div class="flex items-center gap-3">
        <div class="flex rounded-md hover:backdrop-blur-3xl">
            <div class="flex items-center gap-2 py-1 px-2">
                <img class="w-10 h-10 rounded-full" [src]="user.pic ? user.pic : 'assets/svg/utils/avatar_default.svg'"
                    alt="Profile">
                <div class="font-normal text-md text-mg-variant flex flex-col items-start">
                    <p class="font-bold font-manrope">¡Hola!</p>
                    <div class="flex gap-2">
                        <p class="font-manrope">{{user.name | titlecase}}</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <button (click)="toggleNotifications()"
        class=" relative flex items-center justify-center w-10 h-10 rounded-full border-2 border-mg-gray-light text-mg-main-blue bg-white hover:bg-mg-main-blue hover:text-white transition-all duration-200">
        <div class="relative">
            <mg-icon iconName="notifications" [iconClass]="'text-lg'"></mg-icon>
            <span *ngIf="hasUnread()"
                class="absolute -top-1 -right-1 w-2.5 h-2.5 bg-mg-red-intense rounded-full border border-white">
            </span>
        </div>
    </button>
</div>

<mat-menu #menu_profile="matMenu" class="!rounded-2xl  !max-w-xs !min-w-[20rem]">
    <div class="bg-mg-accent flex gap-4 items-center p-4 -mt-2">
        <img class="w-20 h-20 rounded-full !border-4 !border-white"
            [src]="user.pic ? user.pic :  'assets/svg/utils/avatar_default.svg'" alt="Profile" />
        <div class="text-white">
            <p class="text-sm">{{user.name | titlecase}}</p>
            <p class="text-xs">{{user.rol | titlecase}}</p>
        </div>
    </div>
    <ng-container *ngFor="let item of items;">
        <button class="flex w-full gap-2 items-center justify-between !p-4 hover:bg-mg-base-background"
            [routerLink]="[item.route]" [queryParams]="item.queryParms">
            <div class="flex gap-2 items-center">
                <mg-icon iconClass="text-mg-accent text-4xl" [iconName]="item.icon"></mg-icon>
                <div class="text-left">
                    <p class="text-sm text-mg-gray-dark">{{ item.label }}</p>
                    <p class="text-xs text-mg-gray">{{ item.description }}</p>
                </div>
            </div>
            <mg-icon iconClass="text-mg-gray" iconName="chevron_right"></mg-icon>
        </button>
    </ng-container>
</mat-menu>